import { notify } from "../../../utility/Toastify/toastify";
import { setAuthData, signinUpMiniApp } from "../../../redux/main/action/main";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch, useSelector } from "react-redux";
import styles from "../../../styles/Components/mini-app/auth/MiniAppLoginPage.module.css";
import { Button, Form, Input, message } from "antd";
import { useNavigate, useSearchParams } from "react-router-dom";
import { miniAppConfirmationCodeValidation } from "../../../utility/Validation/validation";
import SixDigitInput from "./SixDigitInput";
import { handleBlur } from "../../../utility/action";
import checkedIcon from "../../../asset/Images/verified.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";

function MiniAppConfirmPage({ navigate, setAuthType }) {
  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(miniAppConfirmationCodeValidation),
  });
  const {
    main: { userPass, telegramData },
  } = useSelector((state) => state);

  const [loading, setLoading] = useState(false);
  const [countdown, setCountdown] = useState(20);
  const [code, setCode] = useState("");
  const [resending, setResending] = useState(false);
  const [showVerified, setShowVerified] = useState(false);
  const [params] = useSearchParams();

  const dispatch = useDispatch();
  const redirect = useNavigate();

  const savedUserPass = localStorage.getItem("userPass")?.split(",");
  const savedEmail = savedUserPass?.[0];
  const savedPass = savedUserPass?.[1];

  const telegramAuth = params.get("tgWebAppStartParam");
  const telegramId = telegramData?.telegramId || telegramAuth?.slice(0, 20);

  const resetTimer = () => setCountdown(20);
  const resendCodeHandler = async () => {
    if (countdown > 0 || resending) return;

    setResending(true);

    const configData = {
      operation_mode: "resend_confirmation_code",
      email: savedEmail?.toLowerCase(),
    };

    await axios
      .post(
        "https://weu658vyjj.execute-api.ap-southeast-2.amazonaws.com/dev/api",
        configData,
      )
      .then((res) => {
        // console.log(res?.data);
        notify(
          "Confirmation code sent to your email inbox. Please check your email and enter the code.",
          "success",
        );
      })
      .catch((err) => {
        console.log(err);
        const { message } = err?.response?.data;

        notify(message || JSON.stringify(err), "error");
      })
      .finally(() => {
        resetTimer();
        setResending(false);
      });
  };

  const onSubmit = async (data) => {
    setLoading(true);

    const configData = {
      operation_mode: "cognito_confirm_signup",
      email: savedEmail?.toLowerCase(),
      confirmation_code: data?.confirmationCode,
      password: userPass[1] || savedPass,
    };

    await axios
      .post(
        "https://weu658vyjj.execute-api.ap-southeast-2.amazonaws.com/dev/api",
        configData,
      )
      .then((res) => {
        // console.log(res?.data);
        const {
          // message,
          idToken: { jwtToken: token, payload: userData },
          refreshToken: { token: refreshToken },
        } = res?.data;

        dispatch(setAuthData(userData, token, refreshToken));

        axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

        if (telegramId) {
          dispatch(
            signinUpMiniApp(
              telegramId,
              userData["custom:custom_username"],
              userData?.email,
            ),
          );
        }

        setShowVerified(true);
        setTimeout(() => {
          if (navigate) {
            navigate();
          } else {
            // redirect("/mini-login");
            redirect("/mini-portfolio", { replace: true });
          }
        }, 5000);
      })
      .catch((err) => {
        console.log(err);
        const { message } = err?.response?.data;
        setCode("");
        notify(message, "error");
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (countdown > 0) {
      const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [countdown]);

  if (showVerified)
    return (
      <div className={styles.verified}>
        <LazyLoadImage
          src={checkedIcon}
          alt="checked"
          effect="blur"
          height="200px"
          width="200px"
        />
        <h3>Verified successfully.</h3>
        <p>
          Enjoy our features and don't forget to check the market every day.
        </p>
      </div>
    );

  return (
    <div style={!setAuthType ? { padding: "1rem 1rem 0" } : {}}>
      <h4 className={styles.title}>
        <span>Confirm</span> <br />
        Your Account
      </h4>

      <Button className={styles.countdown} loading={resending}>
        {countdown > 0 ? (
          `${countdown}s`
        ) : (
          // `Request a new code in ${countdown}s.`
          <span className={styles.resendCodeBtn} onClick={resendCodeHandler}>
            {resending ? "Resending" : "Resend"} Code
          </span>
        )}
      </Button>

      <Form onFinish={handleSubmit(onSubmit)}>
        <Form.Item
          validateStatus={errors.confirmationCode ? "error" : ""}
          help={errors.confirmationCode ? errors.confirmationCode.message : ""}
          className={`${styles.sixDigitContainer}`}
        >
          <Controller
            name="confirmationCode"
            control={control}
            render={({ field }) => (
              <SixDigitInput
                value={code}
                onChange={(value) => {
                  field.onChange(value);
                  setCode(value);
                }}
                onBlur={(e) => {
                  field.onBlur(e);
                  handleBlur(e);
                }}
              />
            )}
          />

          {/*<Controller*/}
          {/*  name="confirmationCode"*/}
          {/*  control={control}*/}
          {/*  render={({ field }) => (*/}
          {/*    <div className={styles.inputWrapper}>*/}
          {/*      <FaRegCircleCheck color="#454545" />*/}
          {/*      <Input*/}
          {/*        {...field}*/}
          {/*        type="text"*/}
          {/*        onBlur={field.onBlur}*/}
          {/*        placeholder="Enter confirmation code"*/}
          {/*      />*/}
          {/*    </div>*/}
          {/*  )}*/}
          {/*/>*/}
        </Form.Item>

        <Form.Item style={{ textAlign: "center", marginTop: "2rem" }}>
          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            className={styles.submitBtn}
          >
            Confirm
          </Button>
        </Form.Item>
        <p
          className={styles.createAccountBtn}
          onClick={() => {
            if (!setAuthType) {
              redirect("/mini-login");
            } else {
              setAuthType("login");
            }
          }}
        >
          Back to Login
        </p>
      </Form>
    </div>
  );
}

export default MiniAppConfirmPage;
